import React from 'react';
import { Outlet } from 'react-router-dom';
import { TopBar } from './TopBar';
import { Header } from './Header';
import { Footer } from './Footer';
import { PageTitle } from './PageTitle';
export function Layout() {
  return <div className="min-h-screen flex flex-col" data-id="element-298">
      <PageTitle data-id="element-299" />
      <TopBar data-id="element-300" />
      <Header data-id="element-301" />
      <main className="flex-1" data-id="element-302">
        <Outlet data-id="element-303" />
      </main>
      <Footer data-id="element-304" />
    </div>;
}